var map = {
	"./banner__fixed-extension.png": 61396,
	"./banner__upgrade-bg.png": 64688,
	"./bg__brand-h5.png": 64379,
	"./bg__brand.png": 40974,
	"./bg__fixed-extension-title.png": 81202,
	"./bg__huiyi.png": 84711,
	"./bg__new-user-discount-bottom-v1.png": 27305,
	"./bg__new-user-discount-v1.png": 46023,
	"./bg__pdf.png": 2413,
	"./btn__arrow.png": 66799,
	"./card-close.png": 70968,
	"./card-logo.png": 23657,
	"./card-setting.png": 55021,
	"./card-sound.png": 48438,
	"./card-voice.gif": 99675,
	"./clear_number.png": 37458,
	"./clear_number_hover.png": 32768,
	"./common/icon__copy.svg": 47415,
	"./common/icon__download.svg": 52657,
	"./common/icon__upload.svg": 94035,
	"./download_icon.png": 14080,
	"./download_save.png": 56340,
	"./educationIncentives/50-off.png": 14066,
	"./educationIncentives/bell-icon.png": 53632,
	"./educationIncentives/bell-star.png": 49889,
	"./educationIncentives/bg-line.png": 32710,
	"./educationIncentives/big-line.png": 24581,
	"./educationIncentives/docs-img.png": 55049,
	"./educationIncentives/fireworks.png": 49272,
	"./educationIncentives/qr-code-bg-icon.png": 83285,
	"./educationIncentives/qr-code-bg.png": 48379,
	"./educationIncentives/qr-code.png": 72126,
	"./educationIncentives/red-star.png": 21295,
	"./educationIncentives/short-line.png": 31941,
	"./educationIncentives/submit-icon.png": 66437,
	"./educationIncentives/title-bg.png": 90472,
	"./educationIncentives/world_school_name_list": 32617,
	"./educationIncentives/world_school_name_list.json": 32617,
	"./educationIncentives/yellow-star-45.png": 75120,
	"./educationIncentives/yellow-star.png": 30776,
	"./home-page-v1/action__ctrl-hover.png": 58007,
	"./home-page-v1/banner__edu.png": 89847,
	"./home-page-v1/banner__invite.png": 56976,
	"./home-page-v1/bg__banner.png": 1083,
	"./home-page-v1/bg__browser-active.png": 76365,
	"./home-page-v1/bg__browser-hover.png": 86725,
	"./home-page-v1/bg__comment.png": 22976,
	"./home-page-v1/bg__guide-1.png": 23772,
	"./home-page-v1/bg__guide-2.png": 86327,
	"./home-page-v1/bg__install-video-v1.png": 56653,
	"./home-page-v1/bg__install-video.png": 88961,
	"./home-page-v1/bg__online.png": 14594,
	"./home-page-v1/bg__slogan.png": 41606,
	"./home-page-v1/bg__title-comment.png": 86021,
	"./home-page-v1/bg__title-guide.png": 47218,
	"./home-page-v1/bg__top-bg-invite.png": 78160,
	"./home-page-v1/bg__top-bg1.png": 25999,
	"./home-page-v1/bg__top-bg2.png": 54619,
	"./home-page-v1/bg__video-box.png": 96624,
	"./home-page-v1/bg__video-hover.png": 94934,
	"./home-page-v1/bg__video-pdf.png": 1695,
	"./home-page-v1/bg__video-web.png": 13329,
	"./home-page-v1/figure.gif": 14634,
	"./home-page-v1/icon__close-video-modal-hover.png": 21519,
	"./home-page-v1/icon__close-video-modal.png": 15278,
	"./home-page-v1/icon__download.png": 83286,
	"./home-page-v1/icon__figure-right.png": 64014,
	"./home-page-v1/icon__figure-top.png": 86896,
	"./home-page-v1/icon__hover.png": 54752,
	"./home-page-v1/icon__online.png": 62972,
	"./home-page-v1/icon__pdf.png": 88419,
	"./home-page-v1/icon__play.png": 15172,
	"./home-page-v1/icon__star.png": 34956,
	"./home-page-v1/icon__web.png": 56831,
	"./home-page-v1/img__arrow-right.png": 45144,
	"./home-page-v1/tips__ctrl-action.png": 2219,
	"./home-page-v1/tips__web-click.png": 83242,
	"./home-page-v1/yi.png": 14745,
	"./icon__add.png": 42121,
	"./icon__arrow-right-gray-hover.png": 58914,
	"./icon__arrow-right-gray.png": 83722,
	"./icon__arrow_down.png": 88745,
	"./icon__arrow_up.png": 5899,
	"./icon__bell.png": 84099,
	"./icon__card-delete.png": 84997,
	"./icon__card-link.png": 74789,
	"./icon__card-video.png": 79594,
	"./icon__celebrate.png": 39301,
	"./icon__checkbox-checked.png": 23170,
	"./icon__checkbox-hover.png": 47144,
	"./icon__checkbox.png": 92017,
	"./icon__close-with-border-hover.png": 5039,
	"./icon__close-with-border-v1.png": 92786,
	"./icon__close-with-border.png": 70089,
	"./icon__close.png": 15315,
	"./icon__default-avatar.png": 3225,
	"./icon__default-favicon.png": 35585,
	"./icon__delete-hover.png": 98019,
	"./icon__delete.png": 92450,
	"./icon__edit-hover.png": 65428,
	"./icon__edit.png": 4851,
	"./icon__empty.png": 71722,
	"./icon__favorite-empty.png": 27099,
	"./icon__key.png": 76407,
	"./icon__lang-empty.png": 19866,
	"./icon__lingdang.png": 79254,
	"./icon__logo.png": 4717,
	"./icon__model.png": 30695,
	"./icon__original-hover.png": 91796,
	"./icon__original.png": 4067,
	"./icon__parallel-hover.png": 99249,
	"./icon__parallel.png": 30472,
	"./icon__pointer.png": 18146,
	"./icon__question.png": 36759,
	"./icon__radio-checked.png": 22182,
	"./icon__radio-hover.png": 53655,
	"./icon__radio.png": 25175,
	"./icon__right-arrow.png": 77901,
	"./icon__settings-hover.png": 25363,
	"./icon__settings-v1.png": 68756,
	"./icon__settings.png": 21596,
	"./icon__source-lang.png": 95789,
	"./icon__star-yellow.png": 72187,
	"./icon__star.png": 43513,
	"./icon__stick.png": 64733,
	"./icon__switch-v1.png": 58562,
	"./icon__switch.png": 53228,
	"./icon__tab-favorite-empty.png": 67035,
	"./icon__tab-favorite.png": 35316,
	"./icon__tab-pdf-empty.png": 41656,
	"./icon__tab-pdf.png": 47679,
	"./icon__target-lang.png": 75085,
	"./icon__top-img-v1.png": 57782,
	"./icon__translation-hover.png": 96207,
	"./icon__translation.png": 86883,
	"./icon__vip-free.png": 80402,
	"./icon__vip-vip1.png": 67544,
	"./icon__yi.png": 78008,
	"./image-translate/icon__image.svg": 57319,
	"./image-translate/icon__reload.svg": 24444,
	"./image-translate/icon__upload-img.svg": 35906,
	"./install-arrow-top-icon.png": 85056,
	"./install-bell-icon.png": 75966,
	"./install-store-icon.png": 4807,
	"./learning/icon__add-grasp-v1.png": 92564,
	"./learning/icon__add-unlearned-v1.png": 87777,
	"./learning/icon__arrow.png": 57503,
	"./learning/icon__back.png": 90966,
	"./learning/icon__delete.png": 66033,
	"./learning/icon__in-grasp.png": 19412,
	"./learning/icon__in-unlearned.png": 61957,
	"./learning/icon__pro-lock.png": 82743,
	"./learning/icon__pro-v-lock.png": 7276,
	"./learning/icon__qingzhu.png": 88977,
	"./learning/icon__star.png": 63285,
	"./learning/like.png": 92081,
	"./learning/path__line-1.png": 76,
	"./learning/path__line.png": 18084,
	"./libs/cmaps/78-EUC-H.bcmap": 11095,
	"./libs/cmaps/78-EUC-V.bcmap": 95359,
	"./libs/cmaps/78-H.bcmap": 72902,
	"./libs/cmaps/78-RKSJ-H.bcmap": 61202,
	"./libs/cmaps/78-RKSJ-V.bcmap": 60221,
	"./libs/cmaps/78-V.bcmap": 52302,
	"./libs/cmaps/78ms-RKSJ-H.bcmap": 4295,
	"./libs/cmaps/78ms-RKSJ-V.bcmap": 41540,
	"./libs/cmaps/83pv-RKSJ-H.bcmap": 51674,
	"./libs/cmaps/90ms-RKSJ-H.bcmap": 44224,
	"./libs/cmaps/90ms-RKSJ-V.bcmap": 26976,
	"./libs/cmaps/90msp-RKSJ-H.bcmap": 70775,
	"./libs/cmaps/90msp-RKSJ-V.bcmap": 3538,
	"./libs/cmaps/90pv-RKSJ-H.bcmap": 40861,
	"./libs/cmaps/90pv-RKSJ-V.bcmap": 40786,
	"./libs/cmaps/Add-H.bcmap": 32735,
	"./libs/cmaps/Add-RKSJ-H.bcmap": 3651,
	"./libs/cmaps/Add-RKSJ-V.bcmap": 71895,
	"./libs/cmaps/Add-V.bcmap": 3685,
	"./libs/cmaps/Adobe-CNS1-0.bcmap": 51671,
	"./libs/cmaps/Adobe-CNS1-1.bcmap": 27617,
	"./libs/cmaps/Adobe-CNS1-2.bcmap": 77552,
	"./libs/cmaps/Adobe-CNS1-3.bcmap": 57934,
	"./libs/cmaps/Adobe-CNS1-4.bcmap": 19011,
	"./libs/cmaps/Adobe-CNS1-5.bcmap": 25109,
	"./libs/cmaps/Adobe-CNS1-6.bcmap": 31839,
	"./libs/cmaps/Adobe-CNS1-UCS2.bcmap": 14419,
	"./libs/cmaps/Adobe-GB1-0.bcmap": 65219,
	"./libs/cmaps/Adobe-GB1-1.bcmap": 5524,
	"./libs/cmaps/Adobe-GB1-2.bcmap": 5927,
	"./libs/cmaps/Adobe-GB1-3.bcmap": 74977,
	"./libs/cmaps/Adobe-GB1-4.bcmap": 11672,
	"./libs/cmaps/Adobe-GB1-5.bcmap": 94406,
	"./libs/cmaps/Adobe-GB1-UCS2.bcmap": 28186,
	"./libs/cmaps/Adobe-Japan1-0.bcmap": 65887,
	"./libs/cmaps/Adobe-Japan1-1.bcmap": 77454,
	"./libs/cmaps/Adobe-Japan1-2.bcmap": 35804,
	"./libs/cmaps/Adobe-Japan1-3.bcmap": 66413,
	"./libs/cmaps/Adobe-Japan1-4.bcmap": 93467,
	"./libs/cmaps/Adobe-Japan1-5.bcmap": 87906,
	"./libs/cmaps/Adobe-Japan1-6.bcmap": 21105,
	"./libs/cmaps/Adobe-Japan1-UCS2.bcmap": 37430,
	"./libs/cmaps/Adobe-Korea1-0.bcmap": 16436,
	"./libs/cmaps/Adobe-Korea1-1.bcmap": 81026,
	"./libs/cmaps/Adobe-Korea1-2.bcmap": 5387,
	"./libs/cmaps/Adobe-Korea1-UCS2.bcmap": 3774,
	"./libs/cmaps/B5-H.bcmap": 37239,
	"./libs/cmaps/B5-V.bcmap": 96742,
	"./libs/cmaps/B5pc-H.bcmap": 29613,
	"./libs/cmaps/B5pc-V.bcmap": 73215,
	"./libs/cmaps/CNS-EUC-H.bcmap": 46222,
	"./libs/cmaps/CNS-EUC-V.bcmap": 68852,
	"./libs/cmaps/CNS1-H.bcmap": 32154,
	"./libs/cmaps/CNS1-V.bcmap": 96807,
	"./libs/cmaps/CNS2-H.bcmap": 70528,
	"./libs/cmaps/CNS2-V.bcmap": 5818,
	"./libs/cmaps/ETHK-B5-H.bcmap": 38591,
	"./libs/cmaps/ETHK-B5-V.bcmap": 9660,
	"./libs/cmaps/ETen-B5-H.bcmap": 27149,
	"./libs/cmaps/ETen-B5-V.bcmap": 11237,
	"./libs/cmaps/ETenms-B5-H.bcmap": 39606,
	"./libs/cmaps/ETenms-B5-V.bcmap": 22918,
	"./libs/cmaps/EUC-H.bcmap": 50114,
	"./libs/cmaps/EUC-V.bcmap": 35861,
	"./libs/cmaps/Ext-H.bcmap": 52867,
	"./libs/cmaps/Ext-RKSJ-H.bcmap": 16778,
	"./libs/cmaps/Ext-RKSJ-V.bcmap": 2849,
	"./libs/cmaps/Ext-V.bcmap": 14034,
	"./libs/cmaps/GB-EUC-H.bcmap": 86401,
	"./libs/cmaps/GB-EUC-V.bcmap": 33700,
	"./libs/cmaps/GB-H.bcmap": 94847,
	"./libs/cmaps/GB-V.bcmap": 90673,
	"./libs/cmaps/GBK-EUC-H.bcmap": 76793,
	"./libs/cmaps/GBK-EUC-V.bcmap": 70928,
	"./libs/cmaps/GBK2K-H.bcmap": 72472,
	"./libs/cmaps/GBK2K-V.bcmap": 56183,
	"./libs/cmaps/GBKp-EUC-H.bcmap": 22639,
	"./libs/cmaps/GBKp-EUC-V.bcmap": 94988,
	"./libs/cmaps/GBT-EUC-H.bcmap": 94568,
	"./libs/cmaps/GBT-EUC-V.bcmap": 42532,
	"./libs/cmaps/GBT-H.bcmap": 45076,
	"./libs/cmaps/GBT-V.bcmap": 12140,
	"./libs/cmaps/GBTpc-EUC-H.bcmap": 61679,
	"./libs/cmaps/GBTpc-EUC-V.bcmap": 36380,
	"./libs/cmaps/GBpc-EUC-H.bcmap": 96585,
	"./libs/cmaps/GBpc-EUC-V.bcmap": 39865,
	"./libs/cmaps/H.bcmap": 82422,
	"./libs/cmaps/HKdla-B5-H.bcmap": 46534,
	"./libs/cmaps/HKdla-B5-V.bcmap": 59107,
	"./libs/cmaps/HKdlb-B5-H.bcmap": 77290,
	"./libs/cmaps/HKdlb-B5-V.bcmap": 88761,
	"./libs/cmaps/HKgccs-B5-H.bcmap": 79130,
	"./libs/cmaps/HKgccs-B5-V.bcmap": 11087,
	"./libs/cmaps/HKm314-B5-H.bcmap": 43095,
	"./libs/cmaps/HKm314-B5-V.bcmap": 34962,
	"./libs/cmaps/HKm471-B5-H.bcmap": 93391,
	"./libs/cmaps/HKm471-B5-V.bcmap": 86789,
	"./libs/cmaps/HKscs-B5-H.bcmap": 66978,
	"./libs/cmaps/HKscs-B5-V.bcmap": 60809,
	"./libs/cmaps/Hankaku.bcmap": 75158,
	"./libs/cmaps/Hiragana.bcmap": 12205,
	"./libs/cmaps/KSC-EUC-H.bcmap": 80182,
	"./libs/cmaps/KSC-EUC-V.bcmap": 65475,
	"./libs/cmaps/KSC-H.bcmap": 89150,
	"./libs/cmaps/KSC-Johab-H.bcmap": 1308,
	"./libs/cmaps/KSC-Johab-V.bcmap": 52233,
	"./libs/cmaps/KSC-V.bcmap": 13994,
	"./libs/cmaps/KSCms-UHC-H.bcmap": 39019,
	"./libs/cmaps/KSCms-UHC-HW-H.bcmap": 16280,
	"./libs/cmaps/KSCms-UHC-HW-V.bcmap": 56203,
	"./libs/cmaps/KSCms-UHC-V.bcmap": 78587,
	"./libs/cmaps/KSCpc-EUC-H.bcmap": 89682,
	"./libs/cmaps/KSCpc-EUC-V.bcmap": 26068,
	"./libs/cmaps/Katakana.bcmap": 88723,
	"./libs/cmaps/LICENSE": 18311,
	"./libs/cmaps/NWP-H.bcmap": 17511,
	"./libs/cmaps/NWP-V.bcmap": 91231,
	"./libs/cmaps/RKSJ-H.bcmap": 64840,
	"./libs/cmaps/RKSJ-V.bcmap": 61771,
	"./libs/cmaps/Roman.bcmap": 62767,
	"./libs/cmaps/UniCNS-UCS2-H.bcmap": 6197,
	"./libs/cmaps/UniCNS-UCS2-V.bcmap": 28617,
	"./libs/cmaps/UniCNS-UTF16-H.bcmap": 62022,
	"./libs/cmaps/UniCNS-UTF16-V.bcmap": 62907,
	"./libs/cmaps/UniCNS-UTF32-H.bcmap": 61809,
	"./libs/cmaps/UniCNS-UTF32-V.bcmap": 35222,
	"./libs/cmaps/UniCNS-UTF8-H.bcmap": 11251,
	"./libs/cmaps/UniCNS-UTF8-V.bcmap": 67360,
	"./libs/cmaps/UniGB-UCS2-H.bcmap": 88729,
	"./libs/cmaps/UniGB-UCS2-V.bcmap": 11565,
	"./libs/cmaps/UniGB-UTF16-H.bcmap": 18012,
	"./libs/cmaps/UniGB-UTF16-V.bcmap": 50859,
	"./libs/cmaps/UniGB-UTF32-H.bcmap": 61746,
	"./libs/cmaps/UniGB-UTF32-V.bcmap": 41269,
	"./libs/cmaps/UniGB-UTF8-H.bcmap": 90490,
	"./libs/cmaps/UniGB-UTF8-V.bcmap": 98365,
	"./libs/cmaps/UniJIS-UCS2-H.bcmap": 42029,
	"./libs/cmaps/UniJIS-UCS2-HW-H.bcmap": 97806,
	"./libs/cmaps/UniJIS-UCS2-HW-V.bcmap": 33966,
	"./libs/cmaps/UniJIS-UCS2-V.bcmap": 40339,
	"./libs/cmaps/UniJIS-UTF16-H.bcmap": 55511,
	"./libs/cmaps/UniJIS-UTF16-V.bcmap": 83131,
	"./libs/cmaps/UniJIS-UTF32-H.bcmap": 56694,
	"./libs/cmaps/UniJIS-UTF32-V.bcmap": 32800,
	"./libs/cmaps/UniJIS-UTF8-H.bcmap": 27867,
	"./libs/cmaps/UniJIS-UTF8-V.bcmap": 87280,
	"./libs/cmaps/UniJIS2004-UTF16-H.bcmap": 18945,
	"./libs/cmaps/UniJIS2004-UTF16-V.bcmap": 95549,
	"./libs/cmaps/UniJIS2004-UTF32-H.bcmap": 27143,
	"./libs/cmaps/UniJIS2004-UTF32-V.bcmap": 2787,
	"./libs/cmaps/UniJIS2004-UTF8-H.bcmap": 42733,
	"./libs/cmaps/UniJIS2004-UTF8-V.bcmap": 67312,
	"./libs/cmaps/UniJISPro-UCS2-HW-V.bcmap": 67568,
	"./libs/cmaps/UniJISPro-UCS2-V.bcmap": 78381,
	"./libs/cmaps/UniJISPro-UTF8-V.bcmap": 64090,
	"./libs/cmaps/UniJISX0213-UTF32-H.bcmap": 89071,
	"./libs/cmaps/UniJISX0213-UTF32-V.bcmap": 92121,
	"./libs/cmaps/UniJISX02132004-UTF32-H.bcmap": 69600,
	"./libs/cmaps/UniJISX02132004-UTF32-V.bcmap": 46726,
	"./libs/cmaps/UniKS-UCS2-H.bcmap": 15501,
	"./libs/cmaps/UniKS-UCS2-V.bcmap": 17703,
	"./libs/cmaps/UniKS-UTF16-H.bcmap": 14870,
	"./libs/cmaps/UniKS-UTF16-V.bcmap": 62275,
	"./libs/cmaps/UniKS-UTF32-H.bcmap": 86350,
	"./libs/cmaps/UniKS-UTF32-V.bcmap": 97246,
	"./libs/cmaps/UniKS-UTF8-H.bcmap": 23387,
	"./libs/cmaps/UniKS-UTF8-V.bcmap": 95427,
	"./libs/cmaps/V.bcmap": 71553,
	"./libs/cmaps/WP-Symbol.bcmap": 62111,
	"./loading.gif": 67055,
	"./login/arrow-right.png": 99321,
	"./login/free_right-tag.png": 11352,
	"./login/icon__free-image.png": 16173,
	"./login/icon__free-pdf.png": 10508,
	"./login/icon__free-realtime.png": 30114,
	"./login/icon__free-select.png": 18767,
	"./login/icon__free-text.png": 54313,
	"./login/icon__free-video.png": 19294,
	"./login/icon__free-web.png": 99727,
	"./login/icon__left-title.png": 11111,
	"./login/icon__summary-focus.png": 68410,
	"./login/icon__summary-pdf.png": 53352,
	"./login/icon__summary-video.png": 58602,
	"./login/icon__summary-web.png": 15454,
	"./login/icon__summary.png": 30182,
	"./login/icon__translate.png": 29001,
	"./login/new_user_banner.png": 53229,
	"./login/newuser-banner-bg.png": 28485,
	"./login/pro-image.png": 13201,
	"./login/pro-pdf.png": 24690,
	"./login/pro-realtime.png": 52988,
	"./login/pro-right-tag.png": 63867,
	"./login/pro-select.png": 84277,
	"./login/pro-summary-focus.png": 78348,
	"./login/pro-summary-pdf.png": 40643,
	"./login/pro-summary-video.png": 65100,
	"./login/pro-summary-web.png": 45606,
	"./login/pro-video.png": 75361,
	"./login/pro-web.png": 38829,
	"./login/tag-ai.png": 12132,
	"./login/tag-discount5.png": 37902,
	"./login/tag-pro.png": 45354,
	"./login/tag-read.png": 86733,
	"./logo-learning.svg": 54843,
	"./logo-purple.png": 45162,
	"./logo-select.png": 53808,
	"./logo-transparent.png": 84537,
	"./logo-white-desc.png": 69807,
	"./logo-white.png": 28818,
	"./logo-with-border.png": 32472,
	"./logo-with-name.png": 83681,
	"./online-extension-bg.png": 25974,
	"./online-header-logo.png": 10236,
	"./online__arrow.png": 56559,
	"./online__hands.png": 43699,
	"./online__hook.png": 76771,
	"./online__line.png": 97077,
	"./online__logo.png": 30842,
	"./online__pdf-icon.png": 52577,
	"./online__pdf.png": 46606,
	"./online__pdf_big.png": 44206,
	"./online__pdf_big2.png": 8124,
	"./online__select-icon.png": 96642,
	"./online__select.png": 16050,
	"./online__source-lang.png": 97974,
	"./online__switch.png": 90161,
	"./online__target-lang.png": 77275,
	"./online__video-icon.png": 87611,
	"./online__video.png": 23634,
	"./online__video2.png": 24294,
	"./online__video3.png": 97672,
	"./online__web-icon.png": 45203,
	"./online__web.png": 83181,
	"./online__web2.png": 85376,
	"./online_arrow-right.png": 47969,
	"./online_clear.png": 66737,
	"./online_copy.png": 26396,
	"./option/icon__close-with-border.png": 55232,
	"./option/icon__search.png": 24528,
	"./pdf/alltext.png": 63830,
	"./pdf/bg__loading.png": 8779,
	"./pdf/curve-v1.png": 48914,
	"./pdf/curve.png": 99006,
	"./pdf/dingdang.png": 58411,
	"./pdf/download-pdf-icon-1.png": 46346,
	"./pdf/download-pdf-icon-2.png": 56101,
	"./pdf/edit.png": 30394,
	"./pdf/ext.png": 78147,
	"./pdf/hamburger.png": 80526,
	"./pdf/hover.png": 13791,
	"./pdf/icon__book.png": 8536,
	"./pdf/icon__card-link.png": 11199,
	"./pdf/icon__extension-bg.png": 752,
	"./pdf/icon__history-close.png": 15660,
	"./pdf/icon__history-delete.png": 41900,
	"./pdf/icon__large-pdf.png": 64211,
	"./pdf/icon__loading.png": 94989,
	"./pdf/icon__login-left.png": 25322,
	"./pdf/icon__notification.png": 84175,
	"./pdf/icon__purple-arrow.png": 37788,
	"./pdf/icon__puzzle-fragment.png": 68777,
	"./pdf/icon__translate.png": 35054,
	"./pdf/icon__wx.png": 77671,
	"./pdf/icon_focus.png": 35119,
	"./pdf/icon_key.png": 10147,
	"./pdf/icon_link_pdf.png": 33368,
	"./pdf/icon_link_video.png": 10348,
	"./pdf/icon_new_collect-full.png": 129,
	"./pdf/icon_new_collect.png": 1008,
	"./pdf/icon_pdf_answer.png": 71676,
	"./pdf/icon_title_pdf.png": 31815,
	"./pdf/icon_translation.png": 57394,
	"./pdf/image-book.png": 41095,
	"./pdf/image-search.png": 36185,
	"./pdf/info-icon.png": 4696,
	"./pdf/loading-f.png": 95883,
	"./pdf/loading-icon-v1.png": 68458,
	"./pdf/loading-icon.png": 16315,
	"./pdf/mouse-left.png": 83176,
	"./pdf/next-page.png": 40289,
	"./pdf/paper-icon.png": 21586,
	"./pdf/pdf-icon.png": 64594,
	"./pdf/pdf-logo.png": 33833,
	"./pdf/pdf-upload.png": 17159,
	"./pdf/preview-page.png": 68355,
	"./pdf/record/icon__pdf-delete.png": 25222,
	"./pdf/record/icon__pdf-upload.png": 95650,
	"./pdf/rect.png": 61930,
	"./pdf/report-icon.png": 5629,
	"./pdf/right.png": 54395,
	"./pdf/share-icon.png": 367,
	"./pdf/share-light.png": 62628,
	"./pdf/share-progress.png": 8441,
	"./pdf/share-star.png": 34926,
	"./pdf/share-underline.png": 89777,
	"./pdf/share.png": 56750,
	"./pdf/switch-icon.png": 18722,
	"./pdf/tip-arrow.png": 71924,
	"./pdf/tip1.png": 40152,
	"./pdf/tip2-v1.png": 74096,
	"./pdf/tip2.png": 96147,
	"./pdf/tip3.png": 79029,
	"./pdf/tool-history.png": 20150,
	"./pdf/tool-upload.png": 70134,
	"./pdf/upgrade-bg.png": 98633,
	"./pdf/upload-btn-icon.png": 59665,
	"./pdf/upload-file.png": 2708,
	"./pdf/upload-icon.png": 18033,
	"./pdf/upload-rocket.png": 19530,
	"./pdf/web.png": 62042,
	"./pdf/zoom-in-icon.png": 49022,
	"./pdf/zoom-out-icon.png": 48010,
	"./pdf_favorite.png": 82122,
	"./phone_check.png": 76986,
	"./print_icon.png": 71775,
	"./share/h5-tips.png": 8263,
	"./share/share-qr-code-bg.png": 40939,
	"./share/share-qr-code.png": 34975,
	"./share/wx-logo.png": 22415,
	"./switch-icon.png": 20687,
	"./token-bg.png": 17557,
	"./uninstall-arrow-icon.png": 21633,
	"./uninstall-bg-icon.png": 45667,
	"./uninstall-delete-icon.png": 17298,
	"./uninstall-line-icon.png": 14528,
	"./uninstall-qr-arrow-icon.png": 84535,
	"./uninstall-qr-code-icon.png": 23401,
	"./uninstall-select-arrow-icon.png": 92009,
	"./uninstall-select-down-icon.png": 67684,
	"./uninstall-update-bg-icon.png": 44314,
	"./user/bg__free.png": 13946,
	"./user/bg__pro.png": 42471,
	"./user/bg__prov.png": 21192,
	"./user/icon__edu.png": 56712,
	"./user/icon__free-big.png": 95068,
	"./user/icon__free-v.png": 6706,
	"./user/icon__pro-big.png": 32038,
	"./user/icon__pro-v.png": 81197,
	"./user/icon__proV-v.png": 28366,
	"./user/icon__prov-big.png": 80203,
	"./user/icon__record.png": 5748,
	"./user/icon__setting.png": 7149,
	"./voice.gif": 14588,
	"./welcome-arrow-icon.png": 34640,
	"./welcome-bg-icon2.png": 96348,
	"./welcome-check-icon.png": 944,
	"./welcome-number1.png": 78737,
	"./welcome-number2.png": 35098,
	"./welcome-qrcode-v1.png": 69388,
	"./welcome-qrcode.png": 77991,
	"./welcome_bg-icon.png": 81014,
	"./y-close.png": 49650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8887;